/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_FailedInputs */



/**
* | output |
* | --- |
* | "Something went wrong. Please try again in a moment." |
*
* @param {Newsletter_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const newsletter_failed = /** @type {((inputs?: Newsletter_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("出错了，请稍后再试。")
	return /** @type {LocalizedString} */ ("Something went wrong. Please try again in a moment.")
});